import { format, addDays, startOfWeek, endOfWeek, isSameDay, parseISO, addMinutes, differenceInMinutes, startOfDay, endOfDay } from "date-fns";
import { da } from "date-fns/locale";

export const DA = { locale: da };

export const fmtDate = (d) => format(typeof d === "string" ? parseISO(d) : d, "d. MMM yyyy", DA);
export const fmtTime = (d) => format(typeof d === "string" ? parseISO(d) : d, "HH:mm", DA);
export const fmtDateTime = (d) => format(typeof d === "string" ? parseISO(d) : d, "d. MMM yyyy HH:mm", DA);
export const fmtDayName = (d) => format(typeof d === "string" ? parseISO(d) : d, "EEEE", DA);
export const fmtDayShort = (d) => format(typeof d === "string" ? parseISO(d) : d, "EEE d/M", DA);

export { addDays, startOfWeek, endOfWeek, isSameDay, parseISO, addMinutes, differenceInMinutes, startOfDay, endOfDay };

export function isoLocal(date) {
  // Returns ISO string in local time (no Z) for consistent comparisons
  const tzOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - tzOffset).toISOString().slice(0, -1);
}

export function combineDateTime(dateStr, timeStr) {
  // dateStr: "YYYY-MM-DD", timeStr: "HH:MM"
  return `${dateStr}T${timeStr}:00`;
}
